<template>
    <div class="menu-modal-container">
        <div class="menu-modal-content menu-modal-content-background-default">
            <div class="menu-modal-content-header">
                UMA
            </div>
            <div class="menu-modal-content-body">
                <div class="menu-modal-content-title">
                    <div class="menu-modal-icon menu-modal-icon-success">
                        <span class="mdi mdi-help"></span>
                    </div>
                    <div class="menu-modal-content-title-text">
                        <p>¿Está seguro de que desea finalizar la orden?</p>
                    </div>
                </div>
                <div class="menu-modal-main-section">
                    <div class="menu-modal-input-container">
                        <div class="menu-modal-input-container-row">
                            <div class="menu-modal-input-label">
                                Cajas producidas:
                            </div>
                            <input class="menu-modal-input-general menu-modal-input-number" type="number" min="0" step="1" v-model="producedQuantity" />
                        </div>
                        <div class="menu-modal-input-container-row">
                            <div class="menu-modal-input-label">
                                Cajas a producir:
                            </div>
                            <input class="menu-modal-input-general menu-modal-input-number menu-modal-input-disabled" type="number" :value="orderReference.real_quantity" disabled/>
                        </div>
                    </div>
                </div>
                <div class="menu-btn-modal-container">
                    <button :class="isProducedQuantityOkValueClass" :disabled="!isProducedQuantityOkValue" @click="progressOrderReference">Sí, finalizar</button>
                    <button class="menu-modal-btn menu-modal-cancel-btn" @click="closeModal">Cancelar</button>
                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <WarningModal
                v-if="showWarning"
                :warningMessage="warningMessage"
                :closeWarning="closeWarning"
            />
        </transition>
    </div>
</template>

<script>
import WarningModal from '../../../../../common/components/modals/WarningModal.vue';
import { showCustomSuccessSweetAlert, showCustomErrorSweetAlert } from '../../../../../common/utils';
import axios from 'axios';
export default {
    name: "FinishOrderReferenceButtonActionModal",
    components: {
        WarningModal
    },
    props: {
        closeModal: {
            type: Function,
            required: true,
        },
        orderReference: {
            type: Object,
            required: true,
        },
        endOfAction: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            producedQuantity: this.orderReference.produced_quantity || 0,
            showWarning: false,
            warningMessage: '',
        }
    },
    methods: {
        progressOrderReference() {
            if (this.producedQuantity < 0) {
                this.openWarning('La cantidad producida no puede ser menor a 0.');
                return;
            }
            this.endOfAction();
            this.closeModal();
            let formData = {
                producedQuantity: this.producedQuantity || 0,
                orderReferenceId: this.orderReference.id,
            }
            axios.post('/api/production-line/progress-order', formData)
                .then(response => {
                    showCustomSuccessSweetAlert('La orden ha sido finalizada correctamente');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        closeWarning() {
            this.showWarning = false;
            this.warningMessage = '';
        },
        openWarning(text) {
            this.warningMessage = text;
            this.showWarning = true;
        },
    },
    computed: {
        isProducedQuantityOkValue() {
            return this.producedQuantity >= 0;
        },
        isProducedQuantityOkValueClass() {
            return this.isProducedQuantityOkValue ? 'menu-modal-btn menu-modal-confirm-btn' : 'menu-modal-btn menu-modal-confirm-btn-disabled';
        },
    }
};
</script>